<div class="container">
  <div class="room-list mt-3 mb-3" *ngIf="offices.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">City</th>
        <th scope="col">Address</th>
        <th scope="col">Phone</th>
        <th scope="col">TimeZone</th>
        <th scope="col">ZkTeco Host</th>
        <th scope="col">ZkTeco Port</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let office of offices">
        <th scope="row">{{office.id}}</th>
        <td>{{office.city}}</td>
        <td>{{office.address}}</td>
        <td>{{office.phone}}</td>
        <td>{{office.timeZone}}</td>
        <td>{{office.zkTecoHost}}</td>
        <td>{{office.zkTecoPort}}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(office)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(office)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
